module.exports = __webpack_public_path__ + "img/clinical-pharmacology.2b191005.png";